export var EmployeeRole;
(function (EmployeeRole) {
    EmployeeRole["Admin"] = "admin";
    EmployeeRole["SubAdmin"] = "subadmin";
    EmployeeRole["Supervisor"] = "supervisor";
    EmployeeRole["Foreman"] = "foreman";
    EmployeeRole["Worker"] = "worker";
})(EmployeeRole || (EmployeeRole = {}));
//# sourceMappingURL=employeeModel.js.map